import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface SmashStore {
  isLoading: boolean;
}

type Actions = {
  setLoading: (isLoading: boolean) => void;
};

export const useOpenChestStore = create<SmashStore & Actions>()(
  immer((set) => ({
    isLoading: false,
    setLoading: (isLoading) =>
      set((state) => {
        state.isLoading = isLoading;
      }),
  })),
);
